import { FormGroup, Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { FC, useEffect, useState } from "react";
import { DateRangeReportFilter, ReportFilterTargetFields } from "../../api/dtos";

interface IRecencyReportFilterSelectProps {
    applicableFields: ReportFilterTargetFields[],
    dateRangeReportFilters?: DateRangeReportFilter[],
    setDateRangeReportFilters: React.Dispatch<React.SetStateAction<DateRangeReportFilter[] | undefined>>
}

export const DateRangeReportFilterSelect: FC<IRecencyReportFilterSelectProps> = ({
    applicableFields,
    dateRangeReportFilters,
    setDateRangeReportFilters
}) => {

    const handleStartDateChange = (value: DateTime<boolean> | null, _context: any) => {

        const filters = applicableFields.map(field => new DateRangeReportFilter({
            filterTargetField: field,
            startDate: value?.toFormat("yyyy-MM-dd") ?? undefined,
            endDate: dateRangeReportFilters?.find(filter => filter.filterTargetField == field)?.endDate ?? undefined
        }));

        setDateRangeReportFilters(filters);
    }
    
    const handleEndDateChange = (value: DateTime<boolean> | null, _context: any) => {

        const filters = applicableFields.map(field => new DateRangeReportFilter({
            filterTargetField: field,
            startDate: dateRangeReportFilters?.find(filter => filter.filterTargetField == field)?.startDate ?? undefined,
            endDate: value?.toFormat("yyyy-MM-dd") ?? undefined
        }));

        setDateRangeReportFilters(filters);
    }

    const [localStartDate, setLocalStartDate] = useState<DateTime<boolean> | null>(null);
    const [localEndDate, setLocalEndDate] = useState<DateTime<boolean> | null>(null);
    
    useEffect(() => {
        setLocalStartDate(_old => {
            const existingValue = dateRangeReportFilters?.find(filter => filter.filterTargetField && applicableFields.includes(filter.filterTargetField))?.startDate;
            if(!existingValue) {
                return null;
            }
            return DateTime.fromISO(existingValue);
        })
        setLocalEndDate(_old => {
            const existingValue = dateRangeReportFilters?.find(filter => filter.filterTargetField && applicableFields.includes(filter.filterTargetField))?.endDate;
            if(!existingValue) {
                return null;
            }
            return DateTime.fromISO(existingValue);
        })
    }, [dateRangeReportFilters])

    return (
        <FormGroup>
            <Grid
                container
                gap={2}
                sx={{
                    mt: 1
                }}
            >
                <DatePicker
                    onChange={handleStartDateChange}
                    label={"Start Date"}
                    format={"dd/MM/yyyy"}
                    value={localStartDate ?? null}
                />
                <DatePicker
                    onChange={handleEndDateChange}
                    label={"End Date"}
                    format={"dd/MM/yyyy"}
                    value={localEndDate ?? null}
                />
            </Grid>
        </FormGroup>
    )
}